module.exports = __webpack_public_path__ + "img/Tomasso_Jared.7d3d3357.png";